module.exports = __webpack_public_path__ + "img/jiaoxue_jiucuo_bg.8785f0f1.png";